<template>
  <div style="height: 100%;position: relative">
    <div style="text-align: left;font-size: 22px;border-left: white 3px solid;padding: 0 14px">{{ $lang('N01020', '~水流数据~') }}</div>
    <div  style="background-color: rgb(34, 48, 77);border-radius: 10px;margin-top: 15px;padding-left: 15px;height: calc(100% - 40px)">
      <div v-if="!hidden" style="text-align: left;padding: 15px 0">
        <div class="mag_r-20" style="display: inline-block;vertical-align: middle;">
          <span class="mag_r-20">{{ $lang('N01000', '~区域~') }}</span>
          <span>
          <select v-model="building" class="allSelect sele" name="">
             <option :value="''">{{ $lang('N00998', '~所有~') }}</option>
             <option v-for="(item, index) in sortTypeFilter" :key="index" :value="item">{{ item }}</option>
          </select>
        </span>
        </div>
        <div class="mag_r-20" style="display: inline-block;vertical-align: middle">
          <span class="mag_r-20">{{ $lang('N01001', '~线别~') }}</span>
          <span>
          <select v-model="line" class="allSelect sele" name="">
                     <option :value="''">{{ $lang('N00998', '~所有~') }}</option>
                      <option v-for="(item, index) in lineNameFilter" :key="index" :value="item">{{ item }}</option>
          </select>
        </span>
        </div>
        <div class="mag_r-20" style="display: inline-block;vertical-align: middle">
          <span class="mag_r-20">{{ $lang('N01002', '~开始时间~') }}</span>
          <span>
            <div class="xd disp">
          <cander :newWidth="'150px'" class="allInput d_l" v-model="newStartDate"  ></cander>
              <img class="jd" src="../../../assets/img/riqi.png" height="20px" style="margin-left: -27px;margin-top: 5px" alt="">
            </div>
        </span>
        </div>
        <div class="mag_r-20" style="display: inline-block;vertical-align: middle">
          <span class="mag_r-20">{{ $lang('N01003', '~结束时间~') }}</span>
          <span>
            <div class="disp xd">
          <cander :newWidth="'150px'" class="allInput d_l" :min-date="newStartDate" v-model="newEndDate" ></cander>
            <img class="jd" src="../../../assets/img/riqi.png" height="20px" style="margin-left: -27px;margin-top: 5px" alt=""></div>
        </span>
        </div>
          <div class="mag_r-20" style="display: inline-block;vertical-align: middle">
              <span class="mag_r-20">{{ $lang('N01004', '~筛选间隔~') }}</span>
              <span>
                <select v-model="timeType" class="allSelect sele" name="">
                            <option :value="1">{{ $lang('N01005', '~10分钟~') }}</option>
                            <option :value="2">{{ $lang('N01006', '~30分钟~') }}</option>
                            <option :value="3">{{ $lang('N01007', '~1小时~') }}</option>
                            <option :value="4">{{ $lang('N01008', '~4小时~') }}</option>
                </select>
              </span>
          </div>
        <button @click="getParams()" class="btn btn_success mag_l-20 mag_r-20"><span>{{ $lang('N01009', '~搜索~') }}</span></button>
        <div class="mag_r-20" style="display: inline-block;vertical-align: middle">
          <span style="border-radius: 5px;border: 1px solid #eee;padding: 10px 20px;cursor: pointer" @click="exportExcel" class="mag_r-20">{{ $lang('N01010', '~导出数据~') }}</span>
        </div>
      </div>
      <div id="hiddenHistoryList" v-show="dao" class="jz_flex"  style="height: 250px;overflow: auto;">
        <table class="allTable bd ba_white wz_black" border="1" cellspacing="0">
          <thead>
          <tr class="bd">
            <th>{{ $lang('N01000', '~区域~') }}</th>
            <th>{{ $lang('N01001', '~线别~') }}</th>
            <th>{{ $lang('N01021', '~水流~') }}</th>
            <th>{{ $lang('N01013', '~时间~') }}</th>
            <th>{{ $lang('N01014', '~结果~') }}</th>
          </tr>
          </thead>
          <tbody>
          <tr class="bd" :key="index" v-for="(item, index) in maintain">
            <td>{{ item.Building }}</td>
            <td>{{ item.Line }}</td>
            <td>{{ item.Velocity }}</td>
            <td>{{ item.Date }}</td>
            <td>{{ item.Result }}</td>
          </tr>
          </tbody>
        </table>
      </div>
      <div style="position: relative;height: 100%" class="jz_flex">

        <div v-if="showLoading" style="position: absolute;opacity: 1;background: #001E31;display: flex;align-items: center;justify-content: center;right: 20px" class="cover">
          <div style="position: relative;top: -30px">
            <img src="../../../assets/img/newLoading.gif" width="50%"/>
            <p class="font20">{{ $lang('N01015', '~加载中，请耐心等待~') }}</p>
          </div>
        </div>
        <div id="mains1" :style="{'height': !hidden ? 'calc(100vh - 290px)' : '100%'}" style="padding: 20px;border-radius: 10px;width: 100%;"></div>
      </div>
    </div>

  </div>
</template>
<script>
import * as echarts from "echarts";
import lodash from "lodash";
import dayjs from 'dayjs'

export default {
  name: "Datagraph1",
  props: ['hidden'],
  data() {
    return {
      templateArray: [],
      templateData: [],
      sortTypeFilter: [],
      lineNameFilter: [],
      templateDetailArray: [],
      sortName: [],
      lxUserInfo: JSON.parse(sessionStorage.lxUserInfo || '{}'),
      newStartDate: '',
      newEndDate: '',
        timeType: 3,
      building: '',
      line: '',
      dao: false,
      showLoading: false,
      lineName: [],
      deviceSortArray: [],
      deviceSortType: [],
      list: [],
      windChart: {},
      maintain: [
      ],
      echartsData: [
      ]
    };
  },
  created() {
    this.newEndDate = this.$commonJs.todayDate
    this.newStartDate = this.$commonJs.lastWeekDay()
    if (this.lxUserInfo.waterChart) {
      this.windChart = JSON.parse(this.lxUserInfo.waterChart)
      console.log("--------------------->>>..",this.windChart)
    }
    this.getHistoryData()
  },
  methods: {
    getHistoryData () {
      let url = this.$commonJs.returnQuery('/customer/devicePage', {page: 1, size: 99999, parentId: this.lxUserInfo.parentId || ''})
      this.$axiox.cpost(url).then(async msg => {
        if (msg.message === '成功') {
            let newList = []
            if (this.lxUserInfo.devices) {
                for (let i = 0; i < msg.data.content.length; i++) {
                    if (this.lxUserInfo.devices.indexOf(msg.data.content[i].id) >=0) {
                        newList.push(msg.data.content[i])
                    }
                }
            } else {
                newList = msg.data.content
            }
            for (let i = 0; i < newList.length; i++) {
                if (this.templateArray.indexOf(newList[i].templateId) >= 0) {
                    newList[i].templateParam = this.templateData[this.templateArray.indexOf(newList[i].templateId)]
                    newList[i].templateDetail = this.templateDetailArray[this.templateArray.indexOf(newList[i].templateId)]
                } else {
                    const detail = await this.$axiox.cpost('/customer/paramsList?templateId=' + newList[i].templateId)
                    const array = []
                    for (let i = 0; i < detail.data.length; i++) {
                        if (detail.data[i].chart === 2) {
                            array.push(+detail.data[i].paramsAddress)
                        }
                    }
                    //console.log(array,'array')
                    newList[i].templateParam = array
                    newList[i].templateDetail = detail.data
                    this.templateData.push(array)
                    this.templateDetailArray.push(detail.data)
                    this.templateArray.push(newList[i].templateId)
                }
            }
          for (let i = 0; i < newList.length; i++) {
            if (newList[i].sortTypeId && this.deviceSortArray.indexOf(newList[i].sortTypeId) >= 0) {
              this.deviceSortType[this.deviceSortArray.indexOf(newList[i].sortTypeId)].devices.push(newList[i])
            } else {
              this.deviceSortType.push({
                sortTypeId: newList[i].sortTypeId || newList[i].id,
                sortType: newList[i].sortType || newList[i].deviceName,
                buildingName: newList[i].sortType || newList[i].deviceName,
                devices: [newList[i]]
              })
              this.deviceSortArray.push(newList[i].sortTypeId || null)
              if (this.sortTypeFilter.indexOf(newList[i].sortType || newList[i].deviceName) >= 0) {
                //console.log(1)
              } else {
                this.sortTypeFilter.push(newList[i].sortType || newList[i].deviceName)
              }
            }
          }
          for (let i = 0; i < this.deviceSortType.length; i++) {
            const lineIdArray = []
            this.deviceSortType[i].lineData = []
            for (let j = 0; j < this.deviceSortType[i].devices.length; j++) {
              if (this.deviceSortType[i].devices[j].lineId && lineIdArray.indexOf(this.deviceSortType[i].devices[j].lineId) >= 0) {
                this.deviceSortType[i].lineData[lineIdArray.indexOf(this.deviceSortType[i].devices[j].lineId)].devices.push(this.deviceSortType[i].devices[j])
              } else {
                this.deviceSortType[i].lineData.push({
                  lineName: this.deviceSortType[i].devices[j].lineName || this.deviceSortType[i].devices[j].deviceName,
                  lineId: this.deviceSortType[i].devices[j].lineId || this.deviceSortType[i].devices[j].id,
                  devices: [this.deviceSortType[i].devices[j]],
                    portData: [],
                    time: [],
                    deviceName: [],
                    detailData: []
                })
                lineIdArray.push(this.deviceSortType[i].devices[j].lineId || null)
                if (this.lineNameFilter.indexOf(this.deviceSortType[i].devices[j].lineName || this.deviceSortType[i].devices[j].deviceName) >= 0) {
                  //console.log(1)
                } else {
                  this.lineNameFilter.push(this.deviceSortType[i].devices[j].lineName || this.deviceSortType[i].devices[j].deviceName)
                }
              }
            }
          }
          this.deviceList = newList
          this.getParams()
        }
      })
    },
    async getParams () {
      this.showLoading = true
      let date = []
      this.echartsData = []
      if (this.newStartDate && this.newEndDate) {
        date = this.getAllDates(this.newStartDate, this.newEndDate)
      }
      let allDeviceParams = []
      this.maintain = []
      let newArr = {}
      let promiseAll = []
      let nowDeviceList = []

      const deviceBuildingB = this.deviceList.filter(item => item.sortTypeId === 151)
      let indexBuildingB = []

      for (let i = 0; i < this.deviceList.length; i++) {
         //-----------------------------------
         const dev = this.deviceList[i]
          const devIndex = deviceBuildingB.find(item => item.id === dev.id)
          if (devIndex) {
            indexBuildingB.push(i)
          }
          //----------------------------
          if (this.building === '' || (this.deviceList[i].sortType && this.deviceList[i].sortType.indexOf(this.building) >= 0) || this.deviceList[i].deviceName.indexOf(this.building) >= 0) {
              if (this.line === '' || (this.deviceList[i].lineName && this.deviceList[i].lineName.indexOf(this.line) >= 0)  || this.deviceList[i].deviceName.indexOf(this.line) >= 0) {
              let url = '/device/dataOfDeByTime?deviceId=' + this.deviceList[i].id + '&startTime=' + this.newStartDate +' 00:00:00&endTime=' + this.newEndDate +' 23:59:59&t=1635866005546'
              if (this.timeType === 1) {
                  url = '/device/dataOfDeByTenMinutes?deviceId=' + this.deviceList[i].id + '&startTime=' + this.newStartDate +' 00:00:00&endTime=' + this.newEndDate +' 23:59:59&t=1635866005546'
              }
              if (this.timeType === 2) {
                  url = '/device/dataOfDeByHalfHour?deviceId=' + this.deviceList[i].id + '&startTime=' + this.newStartDate +' 00:00:00&endTime=' + this.newEndDate +' 23:59:59&t=1635866005546'
              }
              if (this.timeType === 3) {
                  url = '/device/dataOfDeByOneHour?deviceId=' + this.deviceList[i].id + '&startTime=' + this.newStartDate +' 00:00:00&endTime=' + this.newEndDate +' 23:59:59&t=1635866005546'
              }
              promiseAll.push(this.$axiox.post(url))
            nowDeviceList.push(this.deviceList[i])
          }
        }
      }
      Promise.all(promiseAll).then((e) => {

        const startB = dayjs('2024-10-25 00:00:00')
        const endB = dayjs('2025-5-4 23:59:59')
        for (let i = 0; i < indexBuildingB.length; i++) {
          const eData = JSON.parse(JSON.stringify(e[indexBuildingB[i]]?.data || {}))
          const eInfo = Object.keys(eData)
          for (let j = 0; j < eInfo.length; j++) {
            if (dayjs(eInfo[j]).isAfter(startB) && dayjs(eInfo[j]).isBefore(endB)) {
              delete eData[eInfo[j]]
            }
          }
          e[indexBuildingB[i]] = {
            ...e[indexBuildingB[i]],
            data: eData
          }
        }

        // //console.log('e--------------', e)
        for (let i = 0; i < e.length; i++) {
          let paramsData = e[i] || {data: {}}
          allDeviceParams.push(paramsData?.data)
          for (let i = 0; i < allDeviceParams.length;i++){
            for (let j in allDeviceParams[i]) {
              for (let k in allDeviceParams[i][j]) {
                allDeviceParams[i][j][k].device = nowDeviceList[i]
              }
            }
          }
          for (let j in paramsData.data) {
            for (let k in paramsData.data[j]) {
              paramsData.data[j][k].device = nowDeviceList[i]
                // todo
                newArr[j] = paramsData.data[j]
              // if (parseInt(paramsData.data[j][k].pointId) === 4301 && parseInt(paramsData.data[j][k].value) === 0
              // ) {
              //   newArr[j] = paramsData.data[j]
              // }
            }
          }
        }
        for (let s = 0; s < allDeviceParams.length;s++) {
          for (let i in allDeviceParams[s]) {
            allDeviceParams[s][i].forEach(p => {
                //console.log(p.device && p.device.templateParam && p.device.templateParam, 'p.device && p.device.templateParam && p.device.templateParam')
              if (p.device && p.device.templateParam && p.device.templateParam.indexOf(+p.pointId) >= 0) {
                  let tableData = {
                      Building: p.device.deviceName,
                      Line: p.device.lineName,
                      Velocity: parseFloat(p.value).toFixed(1),
                      Date: i,
                      Result: parseFloat(p.value).toFixed(1) < +this.windChart.warnLine ? 'NG' : 'OK'
                  }
                  //console.log(tableData,'tableData')
                  this.maintain.push(tableData)
              }
            })
          }
        }
        this.maintain = lodash.sortBy(this.maintain, (a) => {
          return `${a.Building}${a.Line}${a.Date}`
        })
          for (let i = 0; i < date.length; i++) {
              let data = {
                  time: date[i],
                  bulidingData: JSON.parse(JSON.stringify(this.deviceSortType))
              }
              let newArray = []
              for (let j in allDeviceParams) {
                  for (let k in allDeviceParams[j]) {
                      if (date[i].split('-')[0] === k.split('-')[0]
                          && date[i].split('-')[1] === k.split('-')[1]
                          && date[i].split('-')[2] === k.split('-')[2].split(' ')[0]
                      ) {
                          for (let o = 0; o < allDeviceParams[j][k].length; o++) {
                              // todo
                              newArray.push(allDeviceParams[j][k][o])
                              // if (parseInt(allDeviceParams[j][k][o].pointId) === 4301 && parseInt(allDeviceParams[j][k][o].value) === 0) {
                              //     newArray.push(allDeviceParams[j][k])
                              // }
                          }
                      }
                  }
              }
              //console.log(newArray, 'newArraynewArraynewArraynewArraynewArraynewArraynewArraynewArraynewArray')
              //console.log( this.deviceSortType, ' this.deviceSortType this.deviceSortType')
              newArray.forEach((j) => {
                  // p.forEach(j => {
                      if (j.device && j.device.templateParam && j.device.templateParam.indexOf(+j.pointId) >= 0) {
                          for (let n = 0; n < data.bulidingData.length; n++) {
                              for (let m = 0; m < data.bulidingData[n].lineData.length; m++) {
                                  for (let s = 0; s < data.bulidingData[n].lineData[m].devices.length; s++) {
                                      if (data.bulidingData[n].lineData[m].devices[s].id === j.device.id) {
                                          data.bulidingData[n].lineData[m].detailData.push(parseFloat(j.value))
                                          data.bulidingData[n].lineData[m].portData.push(j.device.lineName)
                                          data.bulidingData[n].lineData[m].time.push(j.time)
                                          data.bulidingData[n].lineData[m].deviceName.push(j.device.deviceName)
                                      }
                                  }
                              }
                          }
                      }
                  // })
              })
              this.echartsData.push(data)
          }
        this.showLoading = false
        this.show(date)
      })
    },
    getAllDates (begin, end) {
      var arr = []
      var ab = begin.split('-')
      var ae = end.split('-')
      var db = new Date()
      db.setUTCFullYear(ab[0], ab[1] - 1, ab[2])
      var de = new Date()
      de.setUTCFullYear(ae[0], ae[1] - 1, ae[2])
      var unixDb = db.getTime() - 24 * 60 * 60 * 1000
      var unixDe = de.getTime() - 24 * 60 * 60 * 1000
      for (var k = unixDb; k <= unixDe;) {
        k = k + 24 * 60 * 60 * 1000
        arr.push(this.returnTimeDate(parseInt(k), 'YYMMDDHeng'))
      }
      return arr
    },
    // 时间格式
    returnTimeDate (date, type) {
      if (date === null || date === '' || date === undefined) {
        return ''
      } else {
        let newDate = new Date(date)
        let year = newDate.getFullYear()
        let month = newDate.getMonth() + 1
        let Todate = newDate.getDate()
        let hour = newDate.getHours()
        let min = newDate.getMinutes()
        let sec = newDate.getSeconds()
        let zhYear = window.localStorage.getItem('language') === 'en-US' ? '/' : '年'
        let zhMouth = window.localStorage.getItem('language') === 'en-US' ? '/' : '月'
        let zhDate = window.localStorage.getItem('language') === 'en-US' ? ' ' : '日'
        month = month < 10 ? '0' + month : month
        Todate = Todate < 10 ? '0' + Todate : Todate
        hour = hour < 10 ? '0' + hour : hour
        min = min < 10 ? '0' + min : min
        sec = sec < 10 ? '0' + sec : sec
        if (type === 'YYMMDDHHMMSS') {
          return year + '/' + month + '/' + Todate + ' ' + hour + ':' + min + ':' + sec
        } else if (type === 'YYMMDD') {
          return year + '/' + month + '/' + Todate
        } else if (type === 'YYMMDDHHMM') {
          return year + '/' + month + '/' + Todate + ' ' + hour + ':' + min
        } else if (type === 'YYMMDDZH') {
          return year + zhYear + month + zhMouth + Todate + zhDate
        } else if (type === 'YYMMDDHHMMSSHeng') {
          return year + '-' + month + '-' + Todate + ' ' + hour + ':' + min + ':' + sec
        } else if (type === 'YYMMDDHeng') {
          return year + '-' + month + '-' + Todate
        }
      }
    },
    initRamdomData() {
    },
    exportExcel () {
      let html = '<html><head><meta charset=\'utf-8\' /></head><body>'
      html += document.getElementById('hiddenHistoryList').innerHTML
      html += '</body></html>'
      // 实例化一个Blob对象，其构造函数的第一个参数是包含文件内容的数组，第二个参数是包含文件类型属性的对象
      let blob = new Blob([html], {
        type: 'application/vnd.ms-excel'
      })
      let a = document.createElement('a')
      a.href = URL.createObjectURL(blob)
      a.download = '水流数据.xls'
      a.click()
    },
    returnFengsuName (address) {
      if (parseInt(address) === 4306) {
        return '1#主风速'
      }
      if (parseInt(address) === 4308) {
        return '2#主风速'
      }
      if (parseInt(address) === 4310) {
        return '3#主风速'
      }
      if (parseInt(address) === 4312) {
        return '4#主风速'
      }
      if (parseInt(address) === 4314) {
        return '5#主风速'
      }
      if (parseInt(address) === 4316) {
        return '6#主风速'
      }
      if (parseInt(address) === 4318) {
        return '7#主风速'
      }
      if (parseInt(address) === 4320) {
        return '8#主风速'
      }
      if (parseInt(address) === 4322) {
        return '1#支风速'
      }
      if (parseInt(address) === 4324) {
        return '2#支风速'
      }
      if (parseInt(address) === 4326) {
        return '3#支风速'
      }
      if (parseInt(address) === 4328) {
        return '4#支风速'
      }
      if (parseInt(address) === 4330) {
        return '5#支风速'
      }
      if (parseInt(address) === 4332) {
        return '6#支风速'
      }
      if (parseInt(address) === 4334) {
        return '7#支风速'
      }
      if (parseInt(address) === 4336) {
        return '8#支风速'
      }
      if (parseInt(address) === 4338) {
        return '9#支风速'
      }
      if (parseInt(address) === 4340) {
        return '10#支风速'
      }
      if (parseInt(address) === 4342) {
        return '11#支风速'
      }
      if (parseInt(address) === 4344) {
        return '12#支风速'
      }
      if (parseInt(address) === 4346) {
        return '13#支风速'
      }
      if (parseInt(address) === 4348) {
        return '14#支风速'
      }
      if (parseInt(address) === 4350) {
        return '15#支风速'
      }
      if (parseInt(address) === 4352) {
        return '16#支风速'
      }
      return ''
    },
    show(date, yrate, newhours) {
      let that = this
      // const lineName = this.lineName
      // const line = this.line
      var chartDom = document.getElementById("mains1");
      var myChart = echarts.init(chartDom);
      var option;
      let arr = []
      let arr2 = []
      let index = parseFloat(this.windChart.ymin)
      for (let i = index; i < this.windChart.ymax / this.windChart.yjiange; i++) {
        if (parseFloat(parseFloat(index).toFixed(1)) === +this.windChart.preLine) {
          arr.push(parseFloat(parseFloat(index).toFixed(1)))
          arr2.push(parseFloat(parseFloat(index).toFixed(1)) + this.$lang('N01023', '~m/s预警~'))
        } else {
          if (parseFloat(parseFloat(index).toFixed(1)) === +this.windChart.warnLine) {
            arr.push(parseFloat(parseFloat(index).toFixed(1)))
            arr2.push(parseFloat(parseFloat(index).toFixed(1)) + this.$lang('N01022', '~m/s标准~'))
          } else {
            arr.push(parseFloat(parseFloat(index).toFixed(1)))
            arr2.push(parseFloat(parseFloat(index).toFixed(1)) + 'm/s')
          }
        }
        index += parseFloat(this.windChart.yjiange)
      }
      let Yrate = yrate || arr || [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21]
      const hours = newhours || arr2 || Yrate.map((p) => {return p + 'm/s'});
      console.log("hours============>",hours);
      const days = []
      for (let i = 0; i < date.length; i++) {
        days.push(date[i].split('-')[1] + '-' + date[i].split('-')[2])
      }
      let series = []
      // let colorArray = ["#64AD59"]
      let allData = []
      for (let n = 0; n < this.deviceSortType.length; n++) {
        allData.push([])
      }
      for (let i = 0; i < this.echartsData.length; i++) {
        for (let j = 0; j < this.echartsData[i].bulidingData.length; j++) {
          for (let o = 0; o < this.echartsData[i].bulidingData[j].lineData.length; o++) {
            for (let k = 0; k < this.echartsData[i].bulidingData[j].lineData[o].detailData.length; k++) {
              this.lineName.push(this.line.indexOf(o))
              let yRate = -1
              for (let h = 0; h < Yrate.length; h++) {
                if (Yrate[h - 1]) {
                  let value = this.echartsData[i].bulidingData[j].lineData[o].detailData[k]
                  if (value >= Yrate[h - 1] && value < Yrate[h]) {
                    yRate = parseFloat(h - 1) + parseFloat((value - Yrate[h - 1]) / (Yrate[h] - Yrate[h - 1]))
                  }
                }
              }
                let SerData = {deviceName: this.echartsData[i].bulidingData[j].lineData[o].deviceName[k],port: this.echartsData[i].bulidingData[j].lineData[o].portData[k],time: this.echartsData[i].bulidingData[j].lineData[o].time[k], line: (o + 1) + '线', value: [i, parseFloat(parseFloat(yRate).toFixed(1))]}
                allData[j].push(SerData)
            }
          }
        }
      }
      for (let i = 0; i < this.deviceSortType.length; i++) {
        let seriseData = {
          name: this.deviceSortType[i].buildingName,
          type: "scatter",
          itemStyle: {
            // normal: {
            //   color: colorArray[i],
            // },
          },
          data: [],
          animationDelay: function(idx) {
            return idx * 5;
          },
          markLine: {
            silent: true,
            symbol: ["none", "none"],
            data : [{
              // silent:true,             //鼠标悬停事件  true没有，false有
              lineStyle:{               //警戒线的样式  ，虚实  颜色
                type:"solid",
                color:"#ffffff",
                width: 2,
              },
              label:{
                position:'end',
                formatter: that.windChart.warnLine + that.$lang('N01022', '~m/s标准~'),
                color: '#ffffff',
                fontSize: 18
              },
              yAxis: that.windChart.warnLine + this.$lang('N01022', '~m/s标准~')         //  警戒线的标注值，可以有多个yAxis,多条警示线   或者采用   {type : 'average', name: '平均值'}，type值有  max  min  average，分为最大，最小，平均值
            }, {
              // silent:true,             //鼠标悬停事件  true没有，false有
              lineStyle:{               //警戒线的样式  ，虚实  颜色
                type:"dashed",
                width: 2,
                color:"yellow",
              },
              label:{
                position:'end',
                formatter: that.windChart.preLine + that.$lang('N01023', '~m/s预警~'),
                color: '#ffffff',
                fontSize: 18
              },
              yAxis: that.windChart.preLine + this.$lang('N01023', '~m/s预警~')        //  警戒线的标注值，可以有多个yAxis,多条警示线   或者采用   {type : 'average', name: '平均值'}，type值有  max  min  average，分为最大，最小，平均值
            }]
          }
        }
        for (let j = 0; j < allData[i].length; j++) {
          seriseData.data.push(allData[i][j])
        }
        console.log("markLine==========>",seriseData)
        series.push(seriseData)
      }

      option = {
        title: {
          text: this.$lang('N01035', '~水流/日期~'),
          textStyle: {
            color: 'white'
          }
        },
        legend: {
          left: "right",
          textStyle:{
            color:"white"
          }
        },
        backgroundColor: "transparent",
        tooltip: {
          position: "top",
          extraCssText: "background-color: #202F50;border:1px #234A71 solid",
          textStyle: {
            color:"white"
          },
          formatter: (params) => {
            let value = 0
            if (params.value[1].toString().indexOf('.') >= 0) {
              value = (Yrate[Math.floor(params.value[1])] + parseFloat(((Yrate[Math.floor(params.value[1]) + 1] - Yrate[Math.floor(params.value[1])]) * (params.value[1].toString().split('.')[1] / 10)))) + '°'
            } else {
              value = hours[params.value[1]]
            }
            return this.$lang('N01021', '~水流~') + ': ' + parseFloat(parseFloat(value).toFixed(1)) + ' ' + 'm³/h' + '<br/>' +
                   this.$lang('N01013', '~时间~') + ': ' + params.name + '<br/>' +
                   this.$lang('N01000', '~区域~') + ': ' + params.seriesName + '<br/>' +
                   this.$lang('N01001', '~线别~') + ': ' + params.data.port
          }
        },
        grid: {
          left: 50,
          bottom: 40,
          right: 150,
          containLabel: true,
        },
        xAxis: {
          type: "category",
          data: days,
          // boundaryGap: false,
          splitLine: {
            show: false,
          },
          axisLine: {
            show: true,
          },
          axisLabel: {
            show: true,
            textStyle:{
              color:"white",
              fontSize: 18
            }
          }
        },
        yAxis: {
          data: hours,
          type : 'category',
          minInterval: 0.5,
          axisLine: {
            show: true
          },
          axisLabel: {
            show: true,
            textStyle:{
              color:"white",
              fontSize: 18
            }
          }
        },
        series: series,
      };
      option && myChart.setOption(option);
    }
  },
  mounted() {
    this.initRamdomData()
  },
};
</script>

<style scoped></style>
